// frontend/src/services/userService.ts
import api from './api';
import { 
    User, 
    CreateUserDTO, 
    UpdateUserDTO, 
    UserStats,
    ApiResponse 
} from '../types';

const userService = {
    /**
     * Obtener todos los usuarios
     */
    async getAllUsers(filters?: {
        role?: string;
        status?: string;
        search?: string;
    }): Promise<User[]> {
        const params = new URLSearchParams();
        if (filters?.role) params.append('role', filters.role);
        if (filters?.status !== undefined) params.append('status', filters.status);
        if (filters?.search) params.append('search', filters.search);

        const response = await api.get<ApiResponse<User[]>>(
            `/users?${params.toString()}`
        );
        return response.data.data || [];
    },

    /**
     * Obtener un usuario por ID
     */
    async getUserById(id: string): Promise<User> {
        const response = await api.get<ApiResponse<User>>(`/users/${id}`);
        return response.data.data!;
    },

    /**
     * Crear un nuevo usuario
     */
    async createUser(userData: CreateUserDTO): Promise<User> {
        const response = await api.post<ApiResponse<User>>('/users', userData);
        return response.data.data!;
    },

    /**
     * Actualizar un usuario
     */
    async updateUser(id: string, userData: UpdateUserDTO): Promise<User> {
        const response = await api.put<ApiResponse<User>>(`/users/${id}`, userData);
        return response.data.data!;
    },

    /**
     * Activar/Desactivar un usuario
     */
    async toggleUserStatus(id: string, estado: boolean): Promise<User> {
        const response = await api.patch<ApiResponse<User>>(
            `/users/${id}/status`,
            { estado }
        );
        return response.data.data!;
    },

    /**
     * Verificar antes de eliminar
     */
    async verifyDelete(id: string): Promise<{
        canDelete: boolean;
        hasRelations: boolean;
        relationCounts: any;
        user: Partial<User>;
    }> {
        const response = await api.get<ApiResponse<any>>(
            `/users/${id}/verify-delete`
        );
        return response.data.data!;
    },

    /**
     * Eliminar un usuario
     */
    async deleteUser(id: string): Promise<void> {
        await api.delete(`/users/${id}`, {
            data: { confirmDelete: true }
        });
    },

    /**
     * Obtener estadísticas de un usuario
     */
    async getUserStats(id: string): Promise<UserStats> {
        const response = await api.get<ApiResponse<UserStats>>(
            `/users/${id}/stats`
        );
        return response.data.data!;
    }
};

export { userService };
export default userService;
